import NdaUploaded from './NdaUploaded.component';

export default NdaUploaded;
